import { render, staticRenderFns } from "./HomeGame.vue?vue&type=template&id=860a9d04&scoped=true&"
import script from "./HomeGame.vue?vue&type=script&lang=js&"
export * from "./HomeGame.vue?vue&type=script&lang=js&"
import style0 from "./HomeGame.vue?vue&type=style&index=0&id=860a9d04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860a9d04",
  null
  
)

export default component.exports